import { useEffect, useState } from 'react'
import useInterval from '@/util/hook/useInterval.tsx'
import { SECOND } from '@/constant/time.ts'
import { remainingMs } from '@/util/testSession.ts'

const useCountdown = (endsAt: string | null | undefined): number => {
    const [now, setNow] = useState(() => Date.now())

    useEffect(() => {
        setNow(Date.now())
    }, [endsAt])

    const remaining = remainingMs(endsAt, now)
    useInterval(() => setNow(Date.now()), remaining > 0 ? SECOND : null)

    return remaining
}

export default useCountdown
